'use client';
import { useEffect } from 'react';
import t from 'tiny-warning';
import { isProduction } from '../../core/utilities/env.utils.js';

let i = [];
function useDeprecatedProps(p, o, n) {
    useEffect(()=>{
        isProduction() || n.forEach((e)=>{
            let { propName: t$1, deprecatedValues: n, instructions: $ = '' } = e;
            if (o.__dangerouslySuppressWarning) return;
            let s = o[t$1];
            if (void 0 === s) return;
            let a = '', l = '', d = String(t$1), c = String(s), f = Array.isArray(n);
            if (n && (f && n.length > 0 || Object.keys(n).length > 0)) {
                if (f ? n.includes(c) : c in n) {
                    let e = f ? $ : n[c];
                    a = p ? `The "${d}"="${c}" prop value of "${p}" is deprecated. ${e}` : `The "${d}"="${c}" prop value is deprecated. ${e}`, l = `${p}-${d}-${c}`;
                }
            } else a = p ? `The "${d}" prop of "${p}" is deprecated. ${$}` : `The "${d}" prop is deprecated. ${$}`, l = `${p}-${d}`;
            let u = '' !== a && !i.includes(l);
            t(!u, a), u && i.push(l);
        });
    }, [
        p,
        o,
        n
    ]);
}

export { useDeprecatedProps };
